import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Checkbox from "../../../atoms/input/checkbox";
import GrayBtn from "../../../atoms/button/grayBtn";
import PretendardText from "../../../atoms/text/pretendardText";
import MemberApi from "../../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import { errorHandler } from "../../../../util/errorHandler";
import RedBtn from "../../../atoms/button/redBtn";
import BlueBtn from "../../../atoms/button/blueBtn";
import SearchBar from "../../../atoms/input/searchBar";
import SelectBoxValue from "../../selectBoxValue";
import CategoryApi from "../../../../api/category.api";
import RelatedProductsPopup from "../../../templates/modal/relatedProductsPopup";
import SelectBoxMultiValue from "../../selectBoxMultiValue";

const OpenSet = ({
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
  setButtonGroupFilterOpen,
}) => {
  const navigate = useNavigate();

  const [alarmFlag, setAlarmFlag] = useState(false);

  // 쿠폰 적용 상품 선택 팝업
  const [couponApplyProductPopupOpen, setCouponApplyProductPopupOpen] =
    useState(false);

  // 지식상점 열람 권한 부여 범위
  const [readBoxOpen, setReadBoxOpen] = useState(false);
  const [selectedRead, setSelectedRead] = useState("없음");

  const [categoryBoxOpen, setCategoryBoxOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [merchIdList, setMerchIdList] = useState([]);

  useEffect(() => {
    getMainCategoryList();

    if (userCheckedIdList?.length === 1) {
      initFunc(userCheckedIdList[0]);
    }
  }, [userCheckedIdList]);

  //  상품 카테고리 가져오기
  const initFunc = async (data) => {
    if (!data.openMerchTitleList) {
      return;
    }

    if (
      data.openAllFlag === false &&
      data.openCategoryIdList.length === 0 &&
      data.openMerchIdList.length === 0
    ) {
      setSelectedRead("없음");
      setSelectedCategory([]);
      setMerchIdList([]);

      return;
    }

    if (data.openAllFlag === true) {
      setSelectedRead("모든 상품");
      setSelectedCategory([]);
      setMerchIdList([]);

      return;
    }

    if (data.openCategoryIdList.length > 0) {
      setSelectedRead("지정 카테고리");
      setSelectedCategory(data.openCategoryIdList);
      setMerchIdList([]);

      return;
    }

    if (data.openMerchIdList.length > 0) {
      setSelectedRead("지정 상품");
      setSelectedCategory([]);
      // 두 배열을 하나로 합침
      const combinedArray = data.openMerchIdList.map((id, index) => ({
        title: data.openMerchTitleList[index],
        id: id,
      }));

      setMerchIdList(combinedArray);

      return;
    }
  };

  //  상품 카테고리 가져오기
  const getMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };
      const response = (await CategoryApi.getListMain(data)).data.data.content;

      let temp = response.map((item) => {
        return {
          value: item.id,
          title: item.title,
        };
      });

      setCategoryList(temp);
    } catch (error) {
      errorHandler(error);
    }
  };

  const openSetFunc = async () => {
    try {
      let memberIdsTemp = userCheckedIdList.map((item) => item.id);

      const data = {
        memberIds: memberIdsTemp,
        alarmFlag: alarmFlag,
      };

      let merchIdListTemp = merchIdList.map((item) => item.id);

      switch (selectedRead) {
        case "없음":
          data.openAllFlag = false;
          data.openCategoryIdList = [];
          data.openMerchIdList = [];
          break;

        case "모든 상품":
          data.openAllFlag = true;
          data.openCategoryIdList = [];
          data.openMerchIdList = [];
          break;

        case "지정 카테고리":
          if (selectedCategory.length === 0) {
            return toast("카테고리를 선택해주세요.");
          }

          data.openAllFlag = false;
          data.openCategoryIdList = selectedCategory;
          data.openMerchIdList = [];
          break;

        case "지정 상품":
          if (merchIdListTemp.length === 0) {
            return toast("상품을 선택해주세요.");
          }

          data.openAllFlag = false;
          data.openCategoryIdList = selectedCategory;
          data.openMerchIdList = merchIdListTemp;
          break;

        default:
          break;
      }

      await MemberApi.memberOpenMerch(data);
      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <FilterWrapper
        style={{
          width: 370,
          top: 36,
          padding: 16,
        }}
      >
        <FilterTitle
          style={{
            marginBottom: 10,
          }}
        >
          지식상점 열람 권한 부여 범위
        </FilterTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          <SelectBoxValue
            selectedValue={selectedRead}
            isOpen={readBoxOpen}
            wrapperHandler={() => {
              setReadBoxOpen(!readBoxOpen);
            }}
            itemList={[
              { title: "없음", value: "없음" },
              { title: "모든 상품", value: "모든 상품" },
              {
                title: "지정 카테고리",
                value: "지정 카테고리",
              },
              { title: "지정 상품", value: "지정 상품" },
            ]}
            selectedValueSetterFunc={setSelectedRead}
          />

          {selectedRead === "지정 카테고리" && (
            <SelectBoxMultiValue
              placeholder={"카테고리 선택"}
              selectedValue={selectedCategory}
              isOpen={categoryBoxOpen}
              wrapperHandler={() => {
                setCategoryBoxOpen(!categoryBoxOpen);
              }}
              itemList={categoryList}
              selectedValueSetterFunc={(value) => {
                if (selectedCategory.some((item02) => item02 === value)) {
                  let groupIdListTemp = selectedCategory.filter(
                    (item02) => item02 !== value
                  );

                  setSelectedCategory(groupIdListTemp);
                } else {
                  setSelectedCategory([...selectedCategory, value]);
                }
              }}
            />
          )}

          {selectedRead === "지정 상품" && (
            <>
              <GrayBtn
                onClick={() => {
                  setCouponApplyProductPopupOpen(true);
                }}
                text="쿠폰 적용 상품 선택"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {merchIdList.map((mItem, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 10,
                        padding: "15px 0px",
                        borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: 500,
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "22px",
                          color: "#aaa",
                        }}
                      >
                        {mItem.title}
                      </PretendardText>
                      <RedBtn
                        style={{
                          backgroundColor: "#313233",
                          minWidth: 60,
                        }}
                        onClick={() => {
                          const temp = merchIdList.filter(
                            (mItemF) => mItemF.id !== mItem.id
                          );
                          setMerchIdList(temp);
                        }}
                      >
                        삭제
                      </RedBtn>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "12px 0px 16px 0px",
            gap: 12,
          }}
        >
          <CheckboxWrapper
            onClick={() => {
              setAlarmFlag(!alarmFlag);
            }}
          >
            <Checkbox
              checked={alarmFlag}
              onChange={() => {
                setAlarmFlag(!alarmFlag);
              }}
            />
            <CheckboxText
              style={{
                fontSize: "15px",
                fontWeight: "500",
                lineHeight: "21.5px",
                color: "#aaa",
              }}
            >
              알림 전송하기
            </CheckboxText>
          </CheckboxWrapper>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <GrayBtn
            style={{
              backgroundColor: "#313233",
            }}
            onClick={() => {
              setButtonGroupFilterOpen((prev) => ({
                ...Object.keys(prev).reduce(
                  (acc, key) => ({ ...acc, [key]: false }),
                  {}
                ),
                read: !prev.read,
              }));
            }}
          >
            취소
          </GrayBtn>
          <GrayBtn
            style={{
              backgroundColor: "#313233",
            }}
            onClick={() => {
              openSetFunc();

              setButtonGroupFilterOpen({
                group: false,
                gradeAndLevel: false,
                point: false,
                coupon: false,
                read: false,
                write: false,
              });
            }}
          >
            적용
          </GrayBtn>
        </div>
      </FilterWrapper>

      {/* 지정 상품 추가 팝업 */}
      {couponApplyProductPopupOpen && (
        <RelatedProductsPopup
          setPopupOpen={setCouponApplyProductPopupOpen}
          setValue={setMerchIdList}
          value={merchIdList}
        />
      )}
    </>
  );
};

export default OpenSet;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;

  cursor: pointer;
`;
